// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"v2_wrapper__xzVx7","sticker":"v2_sticker__aF7uj","homeIcon":"v2_homeIcon__yVssa","small":"v2_small__W7meT"};